import { render } from "./upcomingCourses.vue?vue&type=template&id=15df0996"
import script from "./upcomingCourses.vue?vue&type=script&lang=js"
export * from "./upcomingCourses.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__